<template>
  <div class="twelve columns gap">
    <div class="four columns">
      <el-select

        v-model="uf"
        placement="bottom"
        class="uf"
        :filterable="true"
        placeholder="Selecione"
        :automatic-dropdown="true"
        @change="selectUf"
      >
        <el-option
          v-for="u in ufs"
          :key="u"
          :label="u"
          :value="u"
        />
      </el-select>
    </div>
    <div class="eight columns">
      <el-select

        v-model="selectedCity"
        v-loading="loading"
        placement="bottom"
        :filterable="true"
        no-data-text="Vazio"
        value-key="id"
        placeholder="Selecione Cidade"
        @change="selectCidade"
      >
        <el-option
          v-for="c in cidades"
          :key="c.id"
          :label="c.nome"
          :value="c"
        />
      </el-select>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'pinia';
import { isUndefined, get } from 'lodash';
import { http } from 'apsis-plugin/src';
import { mainStore } from 'operass-spa/src/store/index';

export default {
  props: {
    item: {
      required: true,
    },
  },
  emits: ['update:value'],
  data() {
    return {
      ufs: [],
      cidades: [],
      uf: '',
      selectedCity: this.item,
      loading: false,
    };
  },
  watch: {
    item: {
      handler(n) {
        if (!n || Object.keys(n).length === 0) {
          this.uf = null;
          this.selectedCity = null;
          return;
        }
        if (!isUndefined(n.uf) && n.uf !== this.uf) {
          this.selectUf(n.uf);
        }
        this.uf = n.uf;
        this.selectedCity = n;
      },
      immediate: true,
    },
  },
  created() {
    http.get('dominios/ufs').then((response) => get((response), 'data')).then((data) => { this.ufs = data; });
  },
  methods: {
    ...mapActions(mainStore, ['setServiceLoading']),
    selectUf(current) {
      if (current === '') return;

      this.loading = true;
      this.setServiceLoading(false);
      this.combocidadesuf(current).then((value) => {
        this.cidades = value;
        this.loading = false;
      });
      this.selectedCity = null;
    },
    selectCidade(current) {
      this.$emit('update:value', current);
    },
    combocidadesuf(uf) {
      return http.get(`/cidades/uf/${uf}`).then((response) => get(response, 'data'));
    },
  },
};
</script>
